import type { Subject } from '../../types';
import { subjectTheme } from '../../design/subjects';
import { useT } from '../../i18n';

interface SubjectBadgeProps {
  subject: Subject;
  className?: string;
}

export function SubjectBadge({ subject, className = '' }: SubjectBadgeProps) {
  const { t } = useT();
  const theme = subjectTheme(subject);
  return (
    <span
      className={[
        'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold border',
        className,
      ].join(' ')}
      style={{ backgroundColor: theme.tint, color: theme.ink, borderColor: theme.border }}
    >
      {t(`subject.${subject}`)}
    </span>
  );
}

interface BadgeProps {
  children: React.ReactNode;
  variant?: 'default' | 'teal' | 'sand' | 'muted';
  className?: string;
}

export function Badge({ children, variant = 'default', className = '' }: BadgeProps) {
  const variants = {
    default: 'bg-ink/8 text-ink border-ink/12',
    teal: 'bg-teal/15 text-teal-dark border-teal/25',
    sand: 'bg-sand text-graphite border-sand-dark',
    muted: 'bg-ink/5 text-ink/60 border-ink/8',
  };
  return (
    <span
      className={[
        'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border',
        variants[variant],
        className,
      ].join(' ')}
    >
      {children}
    </span>
  );
}
